import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {TranslatePipe} from '@ngx-translate/core';
import {DocumentHal} from '../../../models/HAL/document-hal.model';
import {LoadingSpinnerService} from '../../../services/loading-spinner.service';

import {HttpClient} from '@angular/common/http';
import {SnackBarService} from '../../../services/snackbar.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-collaborator-preview-pdf-metadata',
  imports: [
    MatButton,
    MatIcon,
    MatIconButton,
    TranslatePipe
  ],
  templateUrl: './collaborator-preview-pdf-metadata.component.html',
  styleUrl: './collaborator-preview-pdf-metadata.component.scss'
})
export class CollaboratorPreviewPdfMetadataComponent implements OnInit {

  @Input()
  documentHal: DocumentHal | undefined;
  @Output()
  documentHalChange = new EventEmitter<DocumentHal>();

  protected downloadLink: string | undefined = undefined;
  protected restoreLink: string | undefined = undefined;

  constructor(private readonly loadingSpinnerService: LoadingSpinnerService,
              private readonly httpClient: HttpClient,
              private readonly snackBarService: SnackBarService,
              private readonly router: Router) {
    this.loadingSpinnerService.hide();
  }

  ngOnInit(): void {
    if (this.documentHal?._links.hasLink('file')) {
      this.downloadLink = this.documentHal?._links.getLink('file')?.getRoute();
    }
    if (this.documentHal?._links.hasLink('restore')) {
      this.restoreLink = this.documentHal?._links.getLink('restore')?.getRoute();
    }
  }

  resetToForm() {
    this.loadingSpinnerService.show();
    this.httpClient.put(this.documentHal?._links.getLink('restore')?.href!, {}).subscribe({
      next: (response) => {
        this.documentHalChange.emit(new DocumentHal(response));
        this.loadingSpinnerService.hide();
      }
    });
  }

  downloadPdf() {
    this.loadingSpinnerService.show();
    if (this.documentHal) {
      this.httpClient.get<Blob>(this.documentHal._links.getLink('file')?.href!, {responseType: "blob" as "json"}).subscribe((response: Blob) => {
        let blob = new Blob([response], {type: 'application/pdf'});
        let url = URL.createObjectURL(blob);
        let anchor = document.createElement("a");
        anchor.download = <string>this.documentHal?.title;
        anchor.href = url;
        anchor.click();
        this.loadingSpinnerService.hide();
      });
      return;
    }
    this.loadingSpinnerService.hide();
    this.snackBarService.open('collaboratorView.snackbars.downloadError', 3, 'error');
  }

  backToCollaboratorView() {
    this.router.navigate([this.documentHal?._links.getLink('case')?.getRoute()]).then();
  }
}
